import React, { useState, useEffect, useCallback } from 'react';
import ArrowDownIcon from '@rsuite/icons/ArrowDown';
import debounce from 'lodash/debounce';
import PlusIcon from '@rsuite/icons/Plus';
import SearchIcon from '@rsuite/icons/Search';
import { moeda } from '../../components/funcoes';
import api from '../../services/api';
import EditarCadastarBairro from './EditarCadastrar/index';
import ImportarBairros from './ImportarBairros/index';
import RankingVendasBairro from './RankingVendasBairro/index';
import {
  Container,
  Dropdown,
  IconButton,
  InputGroup,
  Popover,
  Stack,
  Table,
  Whisper,
} from 'rsuite';
import BairroDelete from './BairroDelete';
import AlterarTaxasLote from './TaxasLote';
import { useAuth } from '../../hooks/auth';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomInput } from '../../components/CustomInput';
import { CustomButton } from '../../components/CustomButton';
import { CustomSelectPicker } from '../../components/CustomSelectPicker';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomCell } from '../../components/CustomCell';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import BairroHorarios from './BairroHorarios';
import { NeighborhoodService } from '../../services/neighborhood/neighborhoood.service';
import { FaMapMarkedAlt } from 'react-icons/fa';

const { Column } = Table;

export default function Bairro() {
  const { id_empresa } = useAuth();
  const [loading, setLoading] = useState(true);
  const [bairros, setBairros] = useState([]);
  const [modalBairro, setModalBairro] = useState(false);
  const [modalImport, setModalImport] = useState(false);
  const [modalRanking, setModalRanking] = useState(false);
  const [modalTaxaLote, setModalTaxaLote] = useState(false);
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const [modalHorarios, setModalHorarios] = useState(false);
  const [bairro, setBairro] = useState(null);
  const [empresa, setEmpresa] = useState([]);

  const [filtroStatus, setFiltroStatus] = useState(1);
  const [buscar, setBuscar] = useState('');
  const { theme } = useCustomTheme();

  const cadastrar = () => {
    setBairro(null);
    setModalBairro(true);
  };

  const abrirDados = (bairro) => {
    setBairro(bairro);
    setModalBairro(true);
  };

  const atualizar = useCallback(async () => {
    let complete = false;
    api
      .get(`bairro/listarGestor/${id_empresa}`)
      .then((res) => {
        setBairros(res.data);
      })
      .catch((error) => console.log({ error }))
      .finally(() => {
        if (complete) {
          setLoading(false);
        } else {
          complete = true;
        }
      });
    api
      .get(`empresa/encontrar/${id_empresa}`)
      .then((res) => {
        setEmpresa(res.data);
      })
      .catch((error) => console.log({ error }))
      .finally(() => {
        if (complete) {
          setLoading(false);
        } else {
          complete = true;
        }
      });
  }, [id_empresa]);

  const editar = async (neighbor, field) => {
    const value =
      field === 'CobraTaxa'
        ? neighbor[field] === 'S'
          ? 'N'
          : 'S'
        : !neighbor[field];

    delete neighbor.DataCadastro;
    await NeighborhoodService.update(neighbor.Id, {
      ...neighbor,
      [field]: value,
    }).then((data) => {
      setBairros((state) => state.map((e) => (e.Id !== data.Id ? e : data)));
    });
  };

  useEffect(() => {
    atualizar();
  }, []);

  const renderMenu = ({ onClose, left, top, className }, ref) => {
    const handleSelect = (eventKey) => {
      onClose();
      if (eventKey === 1) {
        setModalImport(true);
      }
      if (eventKey === 2) {
        setModalTaxaLote(true);
      }
      if (eventKey === 3) {
        setModalRanking(true);
      }
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={1}>Importar Bairros</Dropdown.Item>
          <Dropdown.Item eventKey={2}>Alterar Taxas em Lote</Dropdown.Item>
          <Dropdown.Item eventKey={3}>
            Ranking de Vendas por Bairro
          </Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  const consultar = useCallback(
    async (consulta) => {
      consulta = consulta.substring(4);
      if (consulta === '') {
        atualizar();
      } else {
        await api
          .post('bairro/listarPorNomeGestor', {
            IdEmpresa: id_empresa,
            Consulta: consulta,
          })
          .then((res) => {
            res.data.length > 0 ? setBairros(res.data) : setBairros([]);
            setLoading(false);
          });
      }
    },
    [atualizar, id_empresa],
  );

  const dataAtivos = [
    { label: 'Ver todos', value: null },
    { label: 'Filtrar: Ativos', value: 1 },
    { label: 'Filtrar: Inativos', value: 0 },
  ];

  const debounceSearch = debounce((valor) => {
    let instrucao = '';
    const value_lower = valor?.toLowerCase();

    instrucao += filtroStatus !== null ? ` AND Ativo=${filtroStatus}` : ``;
    instrucao += value_lower
      ? ` AND LOWER(Bairro) LIKE '%${value_lower}%'`
      : ``;
    consultar(instrucao);
    setBuscar(valor);
  }, 1000);

  useEffect(() => {
    if (buscar !== '') {
      debounceSearch(buscar);
    } else {
      debounceSearch('');
    }
  }, [buscar, filtroStatus]);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Bairros"
        subtitle="Gerencie os bairros da sua empresa"
        icon={FaMapMarkedAlt}
        style={{ zIndex: 0 }}
        secondComponent={
          <InputGroup inside style={{ width: '36vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <Stack spacing={10} justifyContent="flex-end">
            <CustomSelectPicker
              data={dataAtivos}
              defaultValue={null}
              searchable={false}
              value={filtroStatus}
              onChange={(value) => setFiltroStatus(value)}
              style={{ width: 140 }}
            />
            <CustomButton
              appearance="primary"
              onClick={() => {
                cadastrar();
              }}
            >
              <PlusIcon style={{ marginRight: 6 }} /> Cadastrar
            </CustomButton>
            <Whisper
              appearance="primary"
              placement="bottomEnd"
              trigger="click"
              speaker={renderMenu}
            >
              <IconButton
                appearance="primary"
                style={{ backgroundColor: theme.colors.primary }}
                icon={<ArrowDownIcon appearance="primary" />}
              />
            </Whisper>
            <DuvidasButton tela="bairro" />
          </Stack>
        }
      />
      <Table
        height={window.innerHeight - 60 - 90}
        autoHeight
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        bordered={true}
        loading={loading}
        data={bairros}
        width={'100%'}
        locale={{
          emptyMessage: 'Nenhum bairro encontrado',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          align="center"
          fixed
        >
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Bairro</CustomHeaderCell>
          <CustomCell dataKey="Bairro" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Taxa</CustomHeaderCell>

          <CustomCell>
            {(rowData) => <>{moeda(rowData.TaxaEntrega)}</>}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          align="center"
          fixed
        >
          <CustomHeaderCell>Cobrar Taxa</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <CustomButton
                appearance={rowData.CobraTaxa === 'S' ? 'primary' : 'ghost'}
                onClick={() => editar(rowData, 'CobraTaxa')}
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  width: 50,
                }}
              >
                {rowData.CobraTaxa === 'S' ? 'Sim' : 'Não'}
              </CustomButton>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={100}
          fixed="right"
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>
          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                <CustomButton
                  onClick={() => editar(rowData, 'Ativo')}
                  appearance={!!rowData.Ativo ? 'primary' : 'ghost'}
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 0,
                    width: 50,
                  }}
                >
                  {' '}
                  {!!rowData.Ativo ? 'Sim' : 'Não'}
                </CustomButton>
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={270}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <>
                <span>
                  <CustomButton
                    color={theme.colors.warning}
                    appearance="ghost"
                    size="xs"
                    onClick={() => {
                      abrirDados(rowData);
                    }}
                  >
                    Editar
                  </CustomButton>
                  {' | '}
                  <CustomButton
                    color={theme.colors.danger}
                    appearance="ghost"
                    size="xs"
                    onClick={() => {
                      setBairro(rowData);
                      setModalConfirmDelete(true);
                    }}
                  >
                    Deletar
                  </CustomButton>
                  {' | '}
                  <CustomButton
                    color={theme.colors.primary}
                    appearance="primary"
                    size="xs"
                    onClick={() => {
                      setBairro(rowData);
                      setModalHorarios(true);
                    }}
                  >
                    Horários
                  </CustomButton>
                </span>
              </>
            )}
          </CustomCell>
        </Column>
      </Table>

      {modalBairro && (
        <EditarCadastarBairro
          modal={modalBairro}
          close={() => setModalBairro(false)}
          empresa={empresa}
          ObjBairro={bairro}
          setBairros={setBairros}
        />
      )}
      {modalImport && (
        <ImportarBairros
          open={modalImport}
          close={() => setModalImport(false)}
          setBairros={setBairros}
        />
      )}

      {modalTaxaLote && (
        <AlterarTaxasLote
          open={modalTaxaLote}
          close={() => setModalTaxaLote(false)}
          bairros={bairros}
          setBairros={setBairros}
        />
      )}

      {modalConfirmDelete && (
        <BairroDelete
          open={modalConfirmDelete}
          close={() => setModalConfirmDelete(false)}
          bairro={bairro}
          setBairros={setBairros}
        />
      )}

      {modalRanking && (
        <RankingVendasBairro
          modal={modalRanking}
          fecharModal={() => setModalRanking(false)}
        />
      )}

      {modalHorarios && (
        <BairroHorarios
          modal={modalHorarios}
          onClose={() => setModalHorarios(false)}
          bairro={bairro}
        />
      )}
    </Container>
  );
}
